import axios from './base'

const url = {
  add: '/api/notebooks',
  rename: (notebookId) => `/api/notebooks/${notebookId}/name`,
  changeTags: (notebookId) => `/api/notebooks/${notebookId}/tags`,
  get: (notebookId) => `/api/notebooks/${notebookId}`,
  addCatalog: (notebookId) => `/api/notebooks/${notebookId}/catalogs`,
  renameCatalog: (notebookId, catalogId) => `/api/notebooks/${notebookId}/catalogs/${catalogId}/name`,
  changeCatalogOrder: (notebookId, catalogId) => `/api/notebooks/${notebookId}/catalogs/${catalogId}/order`,
  changeCatalogParentCatalog: (notebookId, catalogId) => `/api/notebooks/${notebookId}/catalogs/${catalogId}/catalog`,
  removeCatalog: (notebookId, catalogId) => `/api/notebooks/${notebookId}/catalogs/${catalogId}`,
  addNote: (notebookId) => `/api/notebooks/${notebookId}/notes`,
  getNote: (notebookId, noteId) => `/api/notebooks/${notebookId}/notes/${noteId}`,
  renameNote: (notebookId, noteId) => `/api/notebooks/${notebookId}/notes/${noteId}/name`,
  changeNoteContent: (notebookId, noteId) => `/api/notebooks/${notebookId}/notes/${noteId}/content`,
  changeNoteOrder: (notebookId, noteId) => `/api/notebooks/${notebookId}/notes/${noteId}/order`,
  changeNoteCatalog: (notebookId, noteId) => `/api/notebooks/${notebookId}/notes/${noteId}/catalog`,
  changeNoteTags: (notebookId, noteId) => `/api/notebooks/${notebookId}/notes/${noteId}/tags`,
  removeNote: (notebookId, noteId) => `/api/notebooks/${notebookId}/notes/${noteId}`
}

export default {
  async add ({ name }) {
    return await axios.post(url.add, {
      name
    })
  },
  async rename ({ id, name, lastVersion }) {
    return axios.put(url.rename(id), {
      name,
      lastVersion
    })
  },
  async changeTags ({ id, tagNames, lastVersion }) {
    return await axios.put(url.changeTags(id), {
      tagNames,
      lastVersion
    })
  },
  async get (id) {
    return await axios.get(url.get(id))
  },
  async addCatalog ({ notebookId, parentCatalogId, name, order, lastVersion }) {
    return await axios.post(url.addCatalog(notebookId), {
      parentCatalogId,
      name,
      order,
      lastVersion
    })
  },
  async renameCatalog ({ notebookId, catalogId, name, lastVersion }) {
    return await axios.put(url.renameCatalog(notebookId, catalogId), {
      name,
      lastVersion
    })
  },
  async changeCatalogOrder ({ notebookId, catalogId, order, lastVersion }) {
    return await axios.put(url.changeCatalogOrder(notebookId, catalogId), {
      order,
      lastVersion
    })
  },
  async changeCatalogParentCatalog ({ notebookId, catalogId, parentCatalogId, order, lastVersion }) {
    return await axios.put(url.changeCatalogParentCatalog(notebookId, catalogId), {
      parentCatalogId,
      order,
      lastVersion
    })
  },
  async removeCatalog ({ notebookId, catalogId, lastVersion }) {
    return await axios.delete(url.removeCatalog(notebookId, catalogId), {
      data: {
        lastVersion
      }
    })
  },
  async addNote ({ notebookId, name, lastVersion, catalogId, order }) {
    return await axios.post(url.addNote(notebookId), {
      catalogId,
      order,
      name,
      lastVersion
    })
  },
  async renameNote ({ notebookId, noteId, name, lastVersion }) {
    return await axios.put(url.renameNote(notebookId, noteId), {
      name,
      lastVersion
    })
  },
  async changeNoteContent ({ notebookId, noteId, content, lastVersion }) {
    return await axios.put(url.changeNoteContent(notebookId, noteId), {
      content,
      lastVersion
    })
  },
  async changeNoteOrder ({ notebookId, noteId, order, lastVersion }) {
    return await axios.put(url.changeNoteOrder(notebookId, noteId), {
      order,
      lastVersion
    })
  },
  async changeNoteCatalog ({ notebookId, noteId, catalogId, order, lastVersion }) {
    return await axios.put(url.changeNoteCatalog(notebookId, noteId), {
      catalogId,
      order,
      lastVersion
    })
  },
  async changeNoteTags ({ notebookId, noteId, tagNames, lastVersion }) {
    return await axios.put(url.changeNoteTags(notebookId, noteId), {
      tagNames,
      lastVersion
    })
  },
  async getNote ({ notebookId, noteId }) {
    return await axios.get(url.getNote(notebookId, noteId))
  },
  async removeNote ({ notebookId, noteId, lastVersion }) {
    return await axios.delete(url.removeNote(notebookId, noteId), {
      data: {
        lastVersion
      }
    })
  }
}
